<template>
    <div class="o-t-transport-types">
        <div class="o-t-transport-types__name-wrapper">
            <div class="o-t-transport-types__icon">
                <img
                    alt="alt"
                    :src="activeTransportType.files.icon"
                >
            </div>
            <div class="o-t-transport-types__name">
                {{$t('ui.terminal.transport', 'Transport')}}
            </div>
        </div>
        <div class="o-t-transport-types__types-wrapper">
            <div
                :class="[
                    'o-t-transport-types__transport-type',
                    activeTransportType.id === type.id ? 'active' : ''
                ]"
                v-for="type in filrtedPreparedTransports"
                :key="type.id"
                @click="changeTransportType(type)"
            >
                {{type.meta[`name_${getActiveLocale}`]}}
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'

import sortBy from 'lodash/sortBy';

import { PLACEHOLDERS } from "./constants";
import { TRANSPORT_API_MAP } from "@/utils/services/transport";

export default {
    name: 'OTTransportTypes',
    data() {
        return {
            activeTransportType: null,
            avalibleTransport: [],
            intervalPrepareTransportTypes: null
        }
    },
    computed: {
        ...mapGetters([
            't',
            'getListChildren',
            'getActiveLocale',
            'getListChildren',
            'getServicesObjects',
            'getObjectsByCategory',
            'getServiceCategoriesAZ',
            'getOrderedServiceCategories',
        ]),
        getTransportServiceCategoryId() {
            return this.getOrderedServiceCategories.filter(service => {
                return service.meta.is_transport;
            })[0].id;
        },
        preparedTransports() {
            return this.getListChildren(this.getTransportServiceCategoryId);
        },
        transportTypeObjects() {
            return this.preparedTransports.map(({id}) => sortBy(this.getObjectsByCategory(+id), ["distance"]) || []) 
        },
        preparedTransportsWithRuterTransportType() {
            return this.preparedTransports.map((transport) => {
                const transportType = sortBy(this.getObjectsByCategory(+transport.id), ["distance"]) || [];
                const ruterType = this.getTransportTypes(transportType[0]);

                return {...transport, ruter_transport_types: ruterType}
            }) 
        },
        filrtedPreparedTransports() {
            return this.preparedTransportsWithRuterTransportType.filter(transport => 
                this.avalibleTransport.includes(this.getTransportTypes(transport))
            )
        }
    },
    methods: {
        changeTransportType(item) {
            this.activeTransportType = item;
            this.$emit('changeTransportType', item);
        },
        /**
         * We want to exclude transport if API returns empty data
         */
        async filterTransportTypes() {
            let prepareTransportList = [];
            await Promise.all(
                this.transportTypeObjects.map(async (transport ) => {
                    let prepareitemTransportList = [];
                    await Promise.all(
                        transport.map(async (object) => {
                            const objectTransports = await this.getObjectTransports(object)
                            prepareitemTransportList = [...prepareitemTransportList, ...objectTransports]
                        })
                    )
                    prepareTransportList = [...prepareTransportList, prepareitemTransportList]
                })
            )

            this.avalibleTransport = prepareTransportList
                .filter(list => list.length)
                .map(list => this.getTransportTypes(list[0].parentObject))
        },
        /**
         * @param {Objeect} object - service item object, like buss stations
         * @return {Array} - transports who stay in this object
         */
        async getObjectTransports(object) {
            if(!this.getRuterStopId(object)) throw new Error(`Station code is not set for: ${this.getServiceName(object)}`);
            if(!this.getApiProvider(object)) throw new Error(`API provider is not set for: ${this.getServiceName(object)}`);
            let transports = [];

            if(this.getApiProvider(object) && TRANSPORT_API_MAP[this.getApiProvider(object)]){
                transports = this.minPlaceholders ? PLACEHOLDERS.slice(0, 2) : PLACEHOLDERS;
                try{
                    if (this.getApiProvider(object) === 'resrobot') {
                        const { Departure } = await TRANSPORT_API_MAP[this.getApiProvider(object)](this.getRuterStopId(object))
                        transports = this.prepareCommonDataStructure(Departure, object);
                    } else {
                        transports = await TRANSPORT_API_MAP[this.getApiProvider(object)](this.getRuterStopId(object), this.getTransportTypes(object))
                    }
                    this.lastSync = this.$moment()
                }
                catch(error){
                    throw new Error(`${this.apiProvider} data is not available: ${error}` )
                }
            }
            transports = transports.map(transport => ({...transport, parentObject: object}))
            
            return transports
        },
        getRuterStopId(object) {
            return this.t(object, 'ruter_stop_id') || null;
        },
        getServiceName(object) {
            return this.t(object, 'name') || '';
        },
        getApiProvider(object) {
            return this.t(object, 'timetables_api_provider') || null;
        },
        getTransportTypes(object) {
            return this.t(object, 'ruter_transport_types') || null;
        },
    },
    created() {
        this.filterTransportTypes();
        this.intervalPrepareTransportTypes = setInterval(() => {
            this.filterTransportTypes()
        }, 300000)
        this.changeTransportType(this.preparedTransports[0]);
    },
    beforeDestroy() {
        if(this.intervalPrepareTransportTypes) clearInterval(this.intervalPrepareTransportTypes)
    }
}
</script>

<style lang="scss" src="./theme.scss" />